/* TPC - "Complete the look" add handler for the cart drawer. 12 Oct 2026.
 *
 * Cards are rendered by sections/tpc-cart-look.liquid and injected by Symmetry's
 * cc-cart-cross-sell, so a <script> inside them would never run. This file is loaded once from
 * sections/cart-drawer.liquid, outside every data-merge region, and listens at document level.
 *
 * SAME DISCIPLINE AS assets/tpc-cart-insert.js (WS-66):
 *   - one add at a time; every look button is locked synchronously before the request;
 *   - success dispatches on:cart:change, which Symmetry already uses to refresh BOTH the drawer
 *     (cart-form.refresh) and the header count (page-header.refreshHeader);
 *   - buttons are released only after the drawer confirms its merge (on:cart:after-merge);
 *   - unknown state = reload, never re-enable. A non-2xx is not proof the cart is unchanged.
 */
(function () {
  if (window.tpcCartLookBound) return;
  window.tpcCartLookBound = true;

  var busy = false;

  function addUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function lookButtons() {
    return document.querySelectorAll('[data-look-add]');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-look-add]') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (busy || btn.disabled) return;

    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;

    busy = true;
    Array.prototype.forEach.call(lookButtons(), function (b) { b.disabled = true; });
    btn.textContent = 'Adding...';

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart state unknown');
      return r.json();
    })
    .then(function () {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }

      var safety = setTimeout(function () {
        document.removeEventListener('on:cart:after-merge', done);
        window.location.reload();
      }, 5000);

      function done() {
        clearTimeout(safety);
        document.removeEventListener('on:cart:after-merge', done);
        busy = false;
        // If the carousel was re-rendered, these are fresh nodes and this is a no-op.
        // If it was not, the added card says so and stays locked; the rest are released.
        Array.prototype.forEach.call(lookButtons(), function (b) {
          if (b === btn) {
            b.textContent = 'Added';
            b.disabled = true;
          } else {
            b.disabled = false;
          }
        });
      }

      document.addEventListener('on:cart:after-merge', done);
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    })
    .catch(function () {
      window.location.reload();
    });
  }, true);
})();
